import * as React from 'react'

export const StageTask = props => (
  <svg
    width={72}
    height={81}
    viewBox="0 0 72 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_81_12631)">
      <path
        d="M33.1674 8.66097C34.9165 7.63532 37.0835 7.63532 38.8326 8.66097L60.9454 21.6273C62.6597 22.6325 63.7128 24.4708 63.7128 26.458V52.542C63.7128 54.5292 62.6597 56.3675 60.9454 57.3727L38.8326 70.339C37.0835 71.3647 34.9165 71.3647 33.1674 70.339L11.0546 57.3727C9.34033 56.3675 8.28719 54.5292 8.28719 52.542V26.458C8.28719 24.4708 9.34033 22.6325 11.0546 21.6273L33.1674 8.66097Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.1901 15.6192C34.9278 14.6112 37.0722 14.6112 38.8099 15.6192L55.5006 25.3009C57.2277 26.3027 58.2907 28.1483 58.2907 30.1449V49.554C58.2907 51.5506 57.2277 53.3962 55.5006 54.398L38.8099 64.0798C37.0722 65.0877 34.9278 65.0877 33.1901 64.0798L16.4994 54.398C14.7723 53.3962 13.7093 51.5506 13.7093 49.554V30.1449C13.7093 28.1483 14.7723 26.3027 16.4994 25.3009L33.1901 15.6192Z"
        fill="#DB5A5F"
      />
      <path
        d="M33.1674 8.66097C34.9165 7.63532 37.0835 7.63532 38.8326 8.66097L60.9454 21.6273C62.6597 22.6325 63.7128 24.4708 63.7128 26.458V52.542C63.7128 54.5292 62.6597 56.3675 60.9454 57.3727L38.8326 70.339C37.0835 71.3647 34.9165 71.3647 33.1674 70.339L11.0546 57.3727C9.34033 56.3675 8.28719 54.5292 8.28719 52.542V26.458C8.28719 24.4708 9.34033 22.6325 11.0546 21.6273L33.1674 8.66097Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.1901 15.6192C34.9278 14.6112 37.0722 14.6112 38.8099 15.6192L55.5006 25.3009C57.2277 26.3027 58.2907 28.1483 58.2907 30.1449V49.554C58.2907 51.5506 57.2277 53.3962 55.5006 54.398L38.8099 64.0798C37.0722 65.0877 34.9278 65.0877 33.1901 64.0798L16.4994 54.398C14.7723 53.3962 13.7093 51.5506 13.7093 49.554V30.1449C13.7093 28.1483 14.7723 26.3027 16.4994 25.3009L33.1901 15.6192Z"
        fill="#DB5A5F"
      />
      <path
        d="M51.3043 31.678C51.3043 28.8569 49.0174 26.5699 46.1962 26.5699H25.8038C22.9826 26.5699 20.6956 28.8569 20.6956 31.678V40.8978V48.0618V50.1177C20.6956 52.9388 22.9826 55.2258 25.8038 55.2258H46.1962C49.0174 55.2258 51.3043 52.9388 51.3043 50.1177V48.0618V40.8978V31.678Z"
        fill="#FAFCE6"
      />
      <path
        d="M46.6989 46.6048C47.5669 46.6048 48.2711 47.3091 48.2711 48.1771V49.3939C48.2711 50.2619 47.5669 50.9662 46.6989 50.9662H34.2672C33.3994 50.9659 32.6959 50.2618 32.6959 49.3939V48.1771C32.6959 47.3092 33.3994 46.6051 34.2672 46.6048H46.6989ZM46.6989 39.4222C47.5669 39.4222 48.2711 40.1264 48.2711 40.9945V42.2113C48.2711 43.0793 47.5669 43.7835 46.6989 43.7835H34.2672C33.3994 43.7833 32.6959 43.0792 32.6959 42.2113V40.9945C32.6959 40.1266 33.3994 39.4224 34.2672 39.4222H46.6989ZM46.6989 32.2396C47.5667 32.2396 48.2709 32.943 48.2711 33.8109V35.0287C48.2711 35.8967 47.5669 36.6009 46.6989 36.6009H34.2672C33.3994 36.6007 32.6959 35.8966 32.6959 35.0287V33.8109C32.6962 32.9432 33.3995 32.2398 34.2672 32.2396H46.6989Z"
        fill="#C2A085"
      />
      <path
        d="M30.2416 32.6288C30.4737 32.8619 30.4737 33.2399 30.2416 33.473L26.7749 36.9551C26.5428 37.1882 26.1665 37.1882 25.9345 36.9551L23.4132 34.4226C23.1811 34.1895 23.1811 33.8116 23.4132 33.5785L24.0435 32.9454C24.2756 32.7123 24.6519 32.7123 24.8839 32.9454L26.3547 34.4226L28.7709 31.9957C29.0029 31.7626 29.3792 31.7626 29.6113 31.9957L30.2416 32.6288Z"
        fill="#C2A085"
      />
      <path
        d="M30.2412 39.812C30.4733 40.0451 30.4733 40.4231 30.2412 40.6562L26.7749 44.1388C26.5429 44.3719 26.1667 44.3719 25.9346 44.1388L23.4137 41.606C23.1817 41.3729 23.1817 40.9949 23.4137 40.7618L24.044 40.1286C24.276 39.8954 24.6522 39.8954 24.8843 40.1286L26.3548 41.606L28.7707 39.1788C29.0027 38.9456 29.3789 38.9456 29.611 39.1788L30.2412 39.812Z"
        fill="#C2A085"
      />
      <path
        d="M29.7306 46.9947C29.9626 47.2279 29.9626 47.6059 29.7306 47.839L26.2643 51.3216C26.0323 51.5547 25.6561 51.5547 25.424 51.3216L22.9031 48.7888C22.6711 48.5557 22.6711 48.1777 22.9031 47.9445L23.5333 47.3113C23.7654 47.0782 24.1416 47.0782 24.3736 47.3113L25.8442 48.7888L28.2601 46.3615C28.4921 46.1284 28.8683 46.1284 29.1004 46.3615L29.7306 46.9947Z"
        fill="#C2A085"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_81_12631"
        x="-4"
        y="0"
        width="80"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12631"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12631"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
